export default __webpack_public_path__ + "static/media/wizard.bc086ca3.jpeg";